import { login } from '../../api/sys/login.js'
import {getToken ,setToken} from '../../utils/token.js'
import {set_user_info} from '../../config/config.js'
import router from '../../router/index'


const getDefultState = () => {
    return {
        token: null,
        user: null
    }
}

const state = getDefultState()

const mutations = {
    RESET_START: (state) => {
        Object.assign(state,getDefultState())
    },
    SET_TOKEN: (state,token) => {
        state.token = token
    },
    SET_USER: (state,user) => {
        state.user = user
        set_user_info(user)
    }
}

const actions = {
    login({commit},userInfo) {
        const {account, password} = userInfo
        return new Promise((resolve, reject) => {
            login({ account: account, password: password}).then(response => {
              const  data = response.data
              commit('SET_TOKEN', data.token)
              commit('SET_USER',data)
              setToken(data.token)
              resolve()
              if(data.type === "freeman"){
                router.push("/index");
              }else{
                  console.log(data)
                  router.push(data.menus[0].childrenMenu[0].childrenMenu[0].url)
              }
              
            }).catch(error => {
              reject(error)
            })
          })
    }
    
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js